<template>
    <div class="container">
        <div class="container-content">
            <!-- 标题 -->
            <div style="display: flex; justify-content: space-between;">
                <div class="container-content-title">施工单位管理 / {{ selectedUnit.id > 0 ? selectedUnit.deptName : '' }}</div>
                <button class="template" @click="downloadTemplate">
                    <img src="../../assets/iconFolder/common/common_resource_download.png" alt="">
                    <span>下载新增任务模板</span>
                </button>
            </div>
            <!-- 内容 -->
            <div class="content">
                <!-- 左侧施工单位列表 -->
                <div class="unit-div">
                    <ConstructionUnitList :unitList="unitList" :selectedUnitId="selectedUnit.id"></ConstructionUnitList>
                </div>
                <!-- 右侧列表 -->
                <div class="table-list">
                    <!-- 列表头部 -->
                    <div class="table-list-header">
                        <!-- 钻探任务和施工队 -->
                        <div class="table-list-header-btn">
                            <!-- <router-link :to="{ path: '/constructionUnit/constructionTaskList', query: { parameter } }"> -->
                                <button @click="changeTableList('task')" :class="{ isActive: tableListType == 'task' }">钻探任务</button>
                            <!-- </router-link> -->
                            <!-- <router-link :to="{ path: '/constructionUnit/constructionTeamList', query: { parameter } }"> -->
                                <button @click="changeTableList('unit')" :class="{ isActive: tableListType == 'unit' }">施工队</button>
                            <!-- </router-link> -->
                        </div>
                        <!-- 右侧 -->
                        <div>
                            <!-- 钻探任务统计 -->
                            <div v-if="tableListType == 'task'" class="statistics">
                                <div class="num">总数量：<span>{{ selectedUnit.zkCount ? selectedUnit.zkCount : 0 }}</span>个</div>
                                <div class="complete">施工已完成：<span>{{ selectedUnit.zkDoneCount }}</span>个</div>
                                <div class="submit">报告已提交：<span>{{ selectedUnit.zkDocCount }}</span>个</div>
                                <div class="doing">施工进行中：<span>{{ selectedUnit.zkDoingCount }}</span>个</div>
                                <div class="not-start">未开始：<span>{{ selectedUnit.zkNotStartedCount }}</span>个</div>
                            </div>
                            <!-- 施工队统计 -->
                            <div v-else class="statistics">
                                <div class="num">总数量：<span>{{ selectedUnit.teamCount }}</span>个</div>
                            </div>
                        </div>
                    </div>
                    <!-- 列表 -->
                    <div class="table-list-content">
                        <ConstructionTaskList v-if="tableListType == 'task'" :unitObj="selectedUnit"></ConstructionTaskList>
                        <ConstructionTeamList v-else :unitObj="selectedUnit"></ConstructionTeamList>
                    </div>
                </div>
            </div>
        </div>
        <!-- 底部 -->
        <ViewBottom></ViewBottom>
        <!-- 创建施工单位 -->
        <ConstructionUnitAdd ref="constructionUnitAdd" @updateUnitList="requestUnitList"></ConstructionUnitAdd>
    </div>
</template>
<script>
import ViewBottom from '../../components/ViewBottom.vue';
import ConstructionUnitList from './Components/ConstructionUnitList.vue';
import ConstructionUnitAdd from './Components/ConstructionUnitAdd.vue';
import ConstructionTaskList from './Children/ConstructionTaskList/ConstructionTaskList.vue';
import ConstructionTeamList from './Children/ConstructionTeamList/ConstructionTeamList.vue'
import { GetUnitList } from '@/http/api/api-hb'
export default {
    components: { ViewBottom, ConstructionUnitList, ConstructionUnitAdd, ConstructionTaskList, ConstructionTeamList },
    data() {
        return {
            // 列表显示的内容 task:钻探任务 unit:施工队
            tableListType: 'task',
            // 施工单位列表
            unitList: [],
            // 选择施工单位的id
            selectedUnit: { id: 0 },
            // 传递的参数
            // parameter: null
        }
    },
    mounted() {
        this.requestUnitList()
    },
    methods: {
        // 获取施工单位列表
        requestUnitList(id) {
            GetUnitList({ pid: 0 }).then(res => {
                if (res.code == 200) {
                    this.unitList = res.data
                    if (this.selectedUnit)
                    if (id && id > 0) {
                        this.unitList.filter(unit => {
                            if (unit.id == id) this.selectedUnit = unit
                         })
                    } else {
                        this.selectedUnit = this.unitList[0]
                    }
                }
            })
        },
        // 添加施工单位
        addConstructionUnit(unitObj) {
            this.$refs.constructionUnitAdd.showCreateConsUnit(unitObj)
        },
        // 切换列表
        changeTableList(type) {
            this.tableListType = type
            // if (type == 'task') {
            //     this.$router.push({ path: '/constructionUnit/constructionTaskList', query: { parameter: JSON.stringify(this.selectedUnit) } })
            // } else {
            //     this.$router.push({ path: '/constructionUnit/constructionTeamList', query: { parameter: JSON.stringify(this.selectedUnit) } })
            // }
        },
        // 切换施工单位
        changeSelectUnit(unit) {
            this.selectedUnit = unit
            // this.parameter = JSON.stringify(this.selectedUnit)
        },
        // 刷新施工单位列表
        updateUnitObj() {
            this.requestUnitList(this.selectedUnit.id)
        },
        // 下载模板
        downloadTemplate() {
            window.open('/钻探任务导入模板及说明.zip')
        }
    },
}
</script>
<style scoped>
    /* 下载模板按钮 */
    .template {
        display: flex;
        align-items: center;
        cursor: pointer;
    }
    .template img {
        width: 16px;
        height: 16px;
        margin-right: 8px;
    }
    .template span {
        font-size: 16px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #0054A0;
    }
    .container-content .content {
        width: 100%;
        height: calc(100% - 48px);
        display: flex;
    }
    .container-content .content .unit-div {
        width: 460px;
        height: 100%;
        border-radius: 6px;
        background: #fff;
        margin-right: 12px;
    }
    .container-content .content .table-list {
        width: calc(100% - 472px);
        height: 100%;
        border-radius: 6px;
    }
    /* 列表内容 */
    .container-content .content .table-list-content {
        width: 100%;
        height: calc(100% - 48px);
    }
    /* 右侧列表头部 */
    .table-list .table-list-header {
        width: 100%;
        height: 48px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        min-width: 964px;
    }
    .table-list .table-list-header .table-list-header-btn {
        min-width: 360px;
    }
    .table-list .table-list-header button {
        width: 180px;
        height: 48px;
        background: none;
        font-size: 18px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #181818;
        line-height: 25px;
    }
    .table-list .table-list-header button.isActive {
        background: #fff;
    }
    /* 统计信息 */
    .table-list .table-list-header .statistics {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #777777;
        line-height: 20px;
    }
    .table-list .table-list-header .statistics span {
        font-size: 26px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        line-height: 37px;
    }
    /* 总数量 */
    .table-list .table-list-header .statistics .num span {
        color: #000000;
    }
    /* 施工完成 */
    .table-list .table-list-header .statistics .complete {
        margin: 0 28px;
    }
    .table-list .table-list-header .statistics .complete span {
        color: #5FC761;
    }
    /* 报告提交 */
    /* .table-list .table-list-header .statistics .submit {
        margin: 0 28px;
    } */
    .table-list .table-list-header .statistics .submit span {
        color: #F8A800;
    }
    /* 报告提交 */
    .table-list .table-list-header .statistics .doing {
        margin: 0 28px;
    }
    .table-list .table-list-header .statistics .doing span {
        color: #0080F3;
    }
    
    /* 未开始 */
    .table-list .table-list-header .statistics .not-start span {
        color: #A7A7A7;
    }
</style>